import axios from "axios";
import { userActions } from "../store/user";
import { useDispatch } from "react-redux";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export default axios;
